import React, { Component } from 'react'
import '../styles/MobileMenu.css'
import TicketIcon from '../images/icons/ticket.png'
import LACover from '../images/Themes/LA/la-cover.jpg'
import VBNCover from '../images/Themes/VBN/vbn-picture-1.jpg'
import AbattoirCover from '../images/Themes/Abattoir/abattoir-cover.jpg'
import YakuzaCover from '../images/Themes/Yakuza/yakuza-cover.jpg'
import TombeauCover from '../images/Themes/Tombeau/Tombeau-cover.jpg'
import { injectIntl, defineMessages } from "react-intl"
import { Link, withRouter } from 'react-router-dom'

const TikTokIcon = () => (
  <svg className="footer-social-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M15.7 3c.35 2.35 1.72 3.75 4.3 3.9v3.08c-1.49.14-2.8-.34-4.22-1.22v5.77c0 7.34-8.02 9.63-11.25 4.37-2.08-3.39-.81-9.34 5.86-9.58v3.25c-.49.08-1.02.2-1.49.37-1.43.48-2.24 1.39-2.01 3 .43 3.08 6.09 3.99 5.62-2.02V3.01h3.19z" />
  </svg>
)

const InstagramIcon = () => (
  <svg className="footer-social-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <rect x="5" y="5" width="14" height="14" rx="4" />
    <circle cx="12" cy="12" r="3.2" />
    <circle cx="16.45" cy="7.55" r="1" />
  </svg>
)

const FacebookIcon = () => (
  <svg className="footer-social-icon footer-social-facebook" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M14.15 8.05V6.7c0-.64.43-.79.73-.79h1.86V3.06L14.18 3c-2.84 0-3.49 2.12-3.49 3.48v1.57H8.5v3.2h2.19V21h3.46v-9.75h2.32l.3-3.2h-2.62z" />
  </svg>
)

class MobileMenu extends Component {

  constructor(props) {
    super(props)
    this.state = {
      mobileMenu: false
    }
  }

  render() {
    const {intl:{formatMessage}} = this.props
    const themes = [
      {
        path: "/lost-asylum/",
        title: formatMessage(messages.la),
        summary: formatMessage(messages.laSummary),
        image: LACover
      },
      {
        path: "/very-bad-night/",
        title: formatMessage(messages.VBN),
        summary: formatMessage(messages.vbnSummary),
        image: VBNCover
      },
      {
        path: "/abattoir/",
        title: formatMessage(messages.slaughterhouse),
        summary: formatMessage(messages.slaughterhouseSummary),
        image: AbattoirCover
      },
      {
        path: "/yakuza/",
        title: formatMessage(messages.yakuza),
        summary: formatMessage(messages.yakuzaSummary),
        image: YakuzaCover
      },
      {
        path: "/expedition-maudite/",
        title: formatMessage(messages.expedition),
        summary: formatMessage(messages.expeditionSummary),
        image: TombeauCover
      }
    ]
    return(
        <div className="mobile-menu-overlay" id="mobile-menu-overlay">
          <div className="mobile-menu">
            <div className="mobile-menu-links-container">
              <div className="mobile-menu-link-dropdown mobile-menu-link-dropdown--open" id="mobile-menu-link-dropdown">
                <div className="mobile-menu-experience-list">
                  {themes.map(theme => (
                    <Link key={theme.path} to={theme.path} className="mobile-menu-experience-card">
                      <span className="mobile-menu-experience-image" style={{ backgroundImage: `url(${theme.image})` }}></span>
                      <span className="mobile-menu-experience-content">
                        <strong>{theme.title}</strong>
                        <span>{theme.summary}</span>
                      </span>
                      <span className="mobile-menu-experience-arrow" aria-hidden="true"></span>
                    </Link>
                  ))}
                </div>
              </div>
            </div>
            <div className="mobile-menu-secondary-links">
              <Link to="/team-building/">
                {formatMessage(messages.secondaryEnterprise)}
              </Link>
              <span aria-hidden="true"></span>
              <Link to="/carte-cadeaux/">
                {formatMessage(messages.secondaryGiftCard)}
              </Link>
            </div>
            <Link to="/reserver/">
              <div className="cta-booking cta-booking--mobile">
                <div className="ticket-container">
                  <img className="ticket" src={TicketIcon} alt="ticket-icon"/>
                  <div className="cta-booking-text">{formatMessage(messages.book)}</div>
                </div>
              </div>
            </Link>
            <div className="mobile-menu-contact">
              <span>{formatMessage(messages.contactPrompt)}</span>
              <Link to="/contact/">{formatMessage(messages.contact)}</Link>
            </div>
            <div className="social-icons--mobile">
              <a target="_blank" rel="noopener noreferrer" aria-label="TikTok" title="TikTok"
                href="https://www.tiktok.com/@onehour_escapegame"
                className="icon-container">
                <TikTokIcon />
              </a>
              <a target="_blank" rel="noopener noreferrer" aria-label="Facebook" title="Facebook"
                href="https://www.facebook.com/onehourliveescapegame/"
                className="icon-container">
                <FacebookIcon />
              </a>
              <a target="_blank" rel="noopener noreferrer" aria-label="Instagram" title="Instagram"
                href="https://www.instagram.com/onehour_escape/"
                className="icon-container">
                <InstagramIcon />
              </a>
            </div>
          </div>
        </div>
    )
  }
}

const messages = defineMessages({
  contact: {
    id: 'footer.contact',
    defaultMessage: 'Contact'
  },
  contactPrompt: {
    id: 'mobileMenu.contactPrompt',
    defaultMessage: 'Une question ?'
  },
  secondaryEnterprise: {
    id: 'mobileMenu.secondaryEnterprise',
    defaultMessage: 'Entreprise'
  },
  secondaryGiftCard: {
    id: 'mobileMenu.secondaryGiftCard',
    defaultMessage: 'Carte cadeau'
  },
  slaughterhouse: {
    id: 'themes.slaughterhouse',
    defaultMessage: "L'abattoir"
  },
  yakuza: {
    id: 'themes.yakuza',
    defaultMessage: "Yakuza"
  },
  VBN: {
    id: 'themes.VBN',
    defaultMessage: "Very Bad Night"
  },
  la: {
    id: 'themes.la',
    defaultMessage: "Lost Asylum"
  },
  expedition: {
    id: 'themes.expedition',
    defaultMessage: "Expédition Maudite"
  },
  laSummary: {
    id: 'mobileMenu.laSummary',
    defaultMessage: 'Hôpital abandonné, tension psychologique'
  },
  vbnSummary: {
    id: 'mobileMenu.vbnSummary',
    defaultMessage: 'Mission fun après une soirée folle'
  },
  slaughterhouseSummary: {
    id: 'mobileMenu.slaughterhouseSummary',
    defaultMessage: 'Un slasher intense et immersif'
  },
  yakuzaSummary: {
    id: 'mobileMenu.yakuzaSummary',
    defaultMessage: 'Une enquête policière sous pression'
  },
  expeditionSummary: {
    id: 'mobileMenu.expeditionSummary',
    defaultMessage: 'Mystère, exploration et aventure'
  },
  book: {
    id: 'navbar.cta',
    defaultMessage: 'Réserver'
  },
})

export default withRouter(injectIntl(MobileMenu))



// WEBPACK FOOTER //
// ./src/components/MobileMenu.js